import createStyledComponents from "../../../Utils/createStyledComponent";

export const Heading = createStyledComponents("font-semibold text-base", "p");
